<template>
  <v-flex
    layout
    row
    align-center
    :class="[gameType === 'puzzle' ? 'puzzleClass' : null]"
  >
    <v-flex layout column align-center>
      <image-input
        class="imageClass"
        :default="parametersPuzzle.picture"
        :showImageInfos="false"
        :langEdition="langEdition"
        @change-image-input="updatePuzzleImage"
      >
      </image-input>
    </v-flex>
    <v-flex style="margin-left: 50px" layout column align-center>
      <v-text-field
        v-model="parametersPuzzle.nbRow"
        @blur="updatePuzzleParameters"
        :label="$t('gameFormCard.row')"
        outline
        class="puzzleField"
      >
      </v-text-field>
      <v-text-field
        v-model="parametersPuzzle.nbCol"
        @blur="updatePuzzleParameters"
        :label="$t('gameFormCard.column')"
        outline
        class="puzzleField"
      >
      </v-text-field>
    </v-flex>
  </v-flex>
</template>

<script>
import ImageInput from './ImageInput';

export default {
  name: 'GamePuzzle',
  components: {
    ImageInput,
  },
  props: {
    gameType: {
      type: String,
      default: null,
    },
    parameters: {
      type: Object,
      default: null,
    },
    langEdition: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      imageWidth: 200,
      imageHeight: 200,
      parametersPuzzle: {
        nbCol: 0,
        nbRow: 0,
        picture: { url: '', author: '', legend: { fr: '', en: '' } },
      },
    };
  },
  watch: {
    gameType(newValue) {
      return newValue;
    },
  },
  created() {
    if (this.gameType === 'puzzle') {
      if (this.parameters.nbCol) {
        this.parametersPuzzle.nbCol = this.parameters.nbCol;
      }
      if (this.parameters.nbRow) {
        this.parametersPuzzle.nbRow = this.parameters.nbRow;
      }
      if (this.parameters.picture.url) {
        this.parametersPuzzle.picture = this.parameters.picture;
      }
    }
  },
  methods: {
    onImageError(error) {
      console.log('imageError', error.message);
    },
    updatePuzzleParameters() {
      this.$emit('update-puzzle-parameters', this.parametersPuzzle);
    },
    updatePuzzleImage(newImage) {
      this.parametersPuzzle.picture = newImage;
      this.$emit('update-puzzle-image', newImage);
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style lang="sass" scoped>
div.v-input
 width: 300px

.deleteIcon
  max-width: 20px;
  margin-left: 7px;
  margin-right: 10px;

.onlyCheckBox
  max-width: 20px
  margin-left: 5px
  margin-right: 10px
  margin-top: 0px

.checkBoxWithDelete
  max-width: 20px
  max-height: 24px
  margin-left: 5px
  margin-right: 10px
  margin-top: 0px

.surveyClass
  margin-right: 30px
  max-height: 66px
  justify: left

.surveyClassWithDelete
  margin-left: 35px
  max-height: 66px

.closeSurvey
  position: absolute

.mcqClass
  margin-top: 0px
  max-height: 66px

.imageClass
  margin-top: 0px
  margin-bottom: 20px

.readOnlyClass
  pointer-events: none;

.showHintClass
  margin-bottom: 20px;
</style>
